import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import { useParams, Link } from "react-router-dom";
import { doc, getDoc, updateDoc, increment, onSnapshot } from "firebase/firestore";
import { auth, db } from "../../firebase"; //Working one
import "./Ads.css";
import GoogleAd from "../../pages/Ads/GoogleAd";
import { FeaturedAds } from "../../components/FeaturedAds/FeaturedAds";
import MultiplexAd from "./MultiplexAds";
import { LoadingSkeleton } from "../../components/LoadingSkeleton/LoadingSkeleton";
import { Helmet } from 'react-helmet';
import { slugify } from '../../utils/helpers';
import LoginModal from "../../modals/LoginModal/LoginModal";
import { motion } from "framer-motion";
import { useAdsConfig } from '../../hooks/useAdsConfig';
import { COMMON_FIELDS, CATEGORY_FORM_SPECS, FIELD_TYPES } from '../../constants/FormSpecs';
import { FiShare2, FiShield, FiFlag, FiLock, FiMessageSquare, FiEdit2 } from "react-icons/fi";

import { useAuth } from '../../contexts/AuthContext';

import { onAuthStateChanged, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { findSubCategoryId } from "../../utils/categoryMapper";
import { set } from "react-hook-form";
import Modal from "../../components/Modal/Modal";

const AdDetail = () => {
  const { id } = useParams();
  const [ad, setAd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingMoreImages, setLoadingMoreImages] = useState(true);
  const [activeImage, setActiveImage] = useState(0);
  const [loadedImages, setLoadedImages] = useState({});
  const [enrichmentStatus, setEnrichmentStatus] = useState(null);

  // For Chat Functionality
  const { currentUser } = useAuth(); // Logged in user
  const [view, setView] = useState('AD_DETAILS');
  const adsEnabled = useAdsConfig();

  const [sellerName, setSellerName] = useState("Qinto User");
  const [isCurrentUserSeller, setIsCurrentUserSeller] = useState(false);
  const [reportAdData, setReportAdData] = useState(false);

  const closeReportAdModal = () => {
    setReportAdData(false);
  };

  const navigate = useNavigate();

  const openChatWithSeller = async () => {

    if (!currentUser) {
      setIsLoginModalOpen(true);
      return;
    }

    const userRef = doc(db, 'users', ad.userId);
    const userSnap = await getDoc(userRef);

    console.log("User Snap AdDetail:", userSnap.data()); // This is coming null

    navigate('/chat', {
      state: {
        adContext: {
          adId: ad.id,
          adTitle: ad.title,
          sellerId: ad.userId || "SELLER_ID", // 🔥 ensure this exists
          sellerName: ad.username || userSnap.data()?.username || "Qinto User", // 🔥 ensure this exists
          sellerImage: userSnap.data()?.profile_image_url || null
        }
      }
    });
  };


  // 1. DEFINE images safely at the top using optional chaining
  // This prevents the "Cannot read properties of null" crash
  const images = useMemo(() => ad?.photos || [], [ad?.photos]);

  // 2. Preload logic (Now safe because 'images' is defined above)
  useEffect(() => {
    if (images.length > 0) {
      images.forEach((img, index) => {
        const fullUrl = img.full || img;
        const imageObject = new Image();
        imageObject.src = fullUrl;
        imageObject.onload = () => {
          setLoadedImages(prev => ({ ...prev, [index]: true }));
        };
      });
    }
  }, [images]);

  // const handleChatClick = async (e) => {
  //   // If the user is on a mobile device
  //   if (/Android|iPhone/i.test(navigator.userAgent)) {
  //     try {
  //       // Create a unique string the app can recognize
  //       const clipboardTag = `qinto-item-id:${id}`;

  //       // Copy to clipboard
  //       await navigator.clipboard.writeText(clipboardTag);
  //       console.log("Ad ID saved to clipboard for deep linking");
  //     } catch (err) {
  //       console.error("Could not copy to clipboard", err);
  //     }
  //   }
  //   // The link will still open the Play Store as usual
  // };

  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);


  const handleLoginSuccess = (user) => {
    console.log("Successfully logged in:", user);
    // You can save the user to your global state, context, or Redux here

    // After successful login, open the chat with the seller
    openChatWithSeller();
  };

  const fetchAndUpgrade = useCallback(async () => {
    try {
      const docRef = doc(db, 'listings', id);
      const docSnap = await getDoc(docRef);

      // Increment views
      //currently insufficient permissions --> need to shift to the cloud function.
      updateDoc(docRef, { viewCount: increment(1) }).catch(err => console.error(err));

      if (docSnap.exists()) {
        let adData = { id: docSnap.id, ...docSnap.data() };

        setAd(adData);
        setLoading(false);

        if (!adData.isEnriched && adData.reddit_link) {
          setLoadingMoreImages(true);
          console.log("Upgrading photo format...");
          const response = await fetch('https://fetchredditgallery-enge7dg2pq-uc.a.run.app', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              url: adData.reddit_link,
              adId: id // Use 'id' from useParams
            })
          }).then(res => res.json())
            .then(data => {
              if (data.gallery && data.gallery.length > 0) {
                // Only update the photos, title and description remain visible
                setAd(prev => ({ ...prev, photos: data.gallery, isEnriched: true }));

              }
            })
            .catch(err => console.error("Gallery background fetch failed", err));
          setLoadingMoreImages(false);
          // const data = await response.json();
          // if (response.ok && data.gallery) {
          //   adData.photos = data.gallery;
          // }

        }


        if (adData.username) {
          setSellerName(adData.username);
        } else {
          setSellerName(currentUser ? currentUser.displayName || "Qinto User" : "Qinto User");
        }
        setIsCurrentUserSeller(currentUser && adData.userId === currentUser.uid);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
      setLoadingMoreImages(false);
    }
  }, [id]);

  useEffect(() => {
    fetchAndUpgrade();
    window.scrollTo(0, 0);
  }, [fetchAndUpgrade]);

  // Real-time listener for enrichment status updates
  useEffect(() => {
    if (!id) return;
    const docRef = doc(db, 'listings', id);
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        if (data.enrichmentStatus) {
          setEnrichmentStatus(data.enrichmentStatus);
        }
        // If the backend finishes and marks it as enriched, hide the loader immediately
        if (data.isEnriched && data.photos) {
          setAd(prev => prev ? { ...prev, photos: data.photos, isEnriched: true } : prev);
          setLoadingMoreImages(false);
        }
      }
    });
    return () => unsubscribe();
  }, [id]);


  //Get display specifications dynamically

  const getDynamicSpecs = () => {
    if (!ad) return [];

    // 1. Get the mapped Category ID safely
    const mappedIds = findSubCategoryId(ad.category, ad.subCategory);

    // If it's 'Other' or not found, mappedIds might be null. 
    // If so, catId will just be null, which safely returns an empty array below.
    const catId = mappedIds ? mappedIds.categoryId : null;

    // 2. Fetch field arrays based on mapping
    // Remember: our formSpecs uses Category ID (like 'c1') for base specs,
    // and the Sub-Category STRING NAME (like 'Computers & Laptops') for specific overrides.
    const catFields = catId ? (CATEGORY_FORM_SPECS[catId] || []) : [];
    const subCatFields = CATEGORY_FORM_SPECS[ad.subCategory] || [];

    // 3. Merge them (Sub-category overrides main category if names match)
    const mergedFieldsMap = {};

    catFields.forEach(field => {
      mergedFieldsMap[field.name] = field;
    });

    subCatFields.forEach(field => {
      mergedFieldsMap[field.name] = field;
    });

    // 4. Filter out empty values and core UI fields
    return Object.values(mergedFieldsMap).filter(field => {
      // Exclude core fields that already have their own UI in the layout
      if (['title', 'description', 'price'].includes(field.name)) return false;

      const value = ad[field.name];

      // Filter out null, undefined, empty strings, and empty arrays
      if (value === undefined || value === null || value === '') return false;
      if (Array.isArray(value) && value.length === 0) return false;

      return true;
    });
  };

  const displaySpecs = getDynamicSpecs();


  const handleShare = () => {
    const url = window.location.href;
    if (navigator.share) {
      navigator.share({
        title: ad.title,
        text: `Check out this ${ad.title} for ₹${ad.price} on Qinto!`,
        url: url,
      }).catch((error) => console.log('Error sharing', error));
    } else {
      navigator.clipboard.writeText(url);
      alert("Link copied to clipboard!");
    }
  };

  const handleReportAd = () => {
    const subject = encodeURIComponent(`Report Ad: ${ad.title} (ID: ${ad.id})`);
    const body = encodeURIComponent(
      `Hello Qinto Support,\n\n` +
      `I would like to report this ad for the following reason:\n` +
      `[ Please type your reason here - e.g., Spam, Fraud, Inappropriate ]\n\n` +
      `--- Ad Details ---\n` +
      `Ad Link: ${window.location.href}\n` +
      `Ad ID: ${ad.id}\n` +
      `Seller ID: ${ad.userId}\n`
    );

    // Opens the user's default email client (Gmail, Outlook, Apple Mail, etc.)
    window.location.href = `mailto:info@qinto.in?subject=${subject}&body=${body}`;
    closeReportAdModal();
  };

  if (loading) return <LoadingSkeleton type="detail" />;
  if (!ad) return <div className="container loading-spinner">Item not found.</div>;

  return (
    <div className="ad-detail-page">
      <Helmet>
        {/* Standard SEO */}
        <title>{ad.title ? `${ad.title} | Qinto` : "Loading Ad..."}</title>
        <meta name="description" content={ad.description} />
        <link rel="canonical" href={`https://qinto.in/item/${id}/${slugify(ad.title)}`} />

        {/* --- NEW: Social Sharing & Link Preview Tags (OpenGraph) --- */}
        <meta property="og:title" content={`${ad.title} - ₹${ad.price.toLocaleString('en-IN')}`} />
        <meta property="og:description" content={ad.description.substring(0, 150) + '...'} />
        {/* Use the first image as the thumbnail. Fallback to a Qinto logo if no image */}
        <meta property="og:image" content={images[0]?.full || images[0]?.thumb || 'https://qinto.in/default-share-image.png'} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${ad.title} - ₹${ad.price.toLocaleString('en-IN')}`} />
        <meta name="twitter:description" content={ad.description.substring(0, 150) + '...'} />
        <meta name="twitter:image" content={images[0]?.full || images[0]?.thumb || 'https://qinto.in/default-share-image.png'} />

        {/* JSON-LD Product Schema for Google Rich Results */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": ad.title,
            "image": images.map(img => img?.full || img?.thumb || img),
            "description": ad.description,
            "offers": {
              "@type": "Offer",
              "url": window.location.href,
              "priceCurrency": "INR",
              "price": ad.price,
              "availability": "https://schema.org/InStock",
              "itemCondition": "https://schema.org/UsedCondition"
            }
          })}
        </script>
      </Helmet>

      <div className="container">
        <nav className="breadcrumbs" aria-label="breadcrumb">
          <Link to="/">Home</Link>
          <span className="breadcrumb-separator">/</span>
          <Link to="/explore">Marketplace</Link>
          <span className="breadcrumb-separator">/</span>
          {ad.category && (
            <>
              <Link to={`/explore?category=${ad.category}`}>{ad.category}</Link>
              <span className="breadcrumb-separator">/</span>
            </>
          )}
          <span className="breadcrumb-current">{ad.title}</span>
        </nav>

        <button className="back-btn" onClick={() => window.history.back()}>← Back</button>

        <div className="ad-detail-layout">
          <div className="ad-gallery">
            <div
              className="main-image-wrapper"
              onTouchStart={(e) => (window.touchStartX = e.touches[0].clientX)}
              onTouchEnd={(e) => {
                const diff = window.touchStartX - e.changedTouches[0].clientX;

                if (diff > 50) {
                  setActiveImage(prev => (prev === images.length - 1 ? 0 : prev + 1));
                } else if (diff < -50) {
                  setActiveImage(prev => (prev === 0 ? images.length - 1 : prev - 1));
                }
              }}
            >
              {/* SLIDER TRACK */}
              <div
                className="slider-track"
                style={{ transform: `translateX(-${activeImage * 100}%)` }}
              >
                {images.map((img, index) => (
                  <div className="slide" key={index}>

                    {/* BLUR IMAGE */}
                    <img
                      src={img?.thumb || img || "https://via.placeholder.com/600"}
                      alt=""
                      className="main-ad-image thumbnail-blur"
                    />

                    {/* FULL IMAGE */}
                    <img
                      src={img?.full || img || "https://via.placeholder.com/600"}
                      alt={ad.title}
                      onLoad={() =>
                        setLoadedImages(prev => ({ ...prev, [index]: true }))
                      }
                      className={`main-ad-image full-res ${loadedImages[index] ? "loaded" : "loading"
                        }`}
                    />

                    {!loadedImages[index] && (
                      <div className="image-loader-spinner"></div>
                    )}
                  </div>
                ))}
              </div>

              {/* LEFT ARROW */}
              {images.length > 1 && (
                <motion.button
                  className="nav-btn left"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                  transition={{ type: "spring", stiffness: 300 }}
                  onClick={() =>
                    setActiveImage(prev =>
                      prev === 0 ? images.length - 1 : prev - 1
                    )
                  }
                >
                  ‹
                </motion.button>
              )}

              {/* RIGHT ARROW */}
              {images.length > 1 && (
                <motion.button
                  className="nav-btn right"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                  transition={{ type: "spring", stiffness: 300 }}
                  onClick={() =>
                    setActiveImage(prev =>
                      prev === images.length - 1 ? 0 : prev + 1
                    )
                  }
                >
                  ›
                </motion.button>
              )}
            </div>

            {/* NEW: Shimmering text while enriching images */}
            {loadingMoreImages && (
              <div className="image-enrichment-shimmer">
                {enrichmentStatus === "enhancing"
                  ? "✨ More photos found. Enhancing quality of photos..."
                  : "✨ Checking for more photos..."}
              </div>
            )}

            {/* THUMBNAILS */}
            {images.length > 1 && (
              <div className="thumbnail-row">
                {images.map((img, index) => (
                  <img
                    key={index}
                    src={img?.thumb || img}
                    alt=""
                    className={`thumb ${activeImage === index ? "active" : ""}`}
                    onClick={() => setActiveImage(index)}
                  />
                ))}
              </div>
            )}
          </div>

          <div className="listing-info-box">
            <h1 className="detail-title">{ad.title}</h1>
            <div className="price-row-flex">

              <div className="detail-price">₹ {ad.price}</div>
              <button className="qinto-share-action-btn" onClick={handleShare} title="Share this ad">
                <FiShare2 />
              </button>

            </div>


            <div className="detail-meta">
              <span>📍 {ad.location || "Nearby"}</span>
              <span>•</span>
              <span>{ad.createdAt ? new Date(ad.createdAt.seconds * 1000).toLocaleDateString() : "Recently"}</span>
            </div>

            <div className="detail-stats">
              <div className="stat-item">
                <span className="stat-icon">👁️</span>
                <strong>{(ad.viewCount || 0) + 1}</strong> Views
              </div>
              {/* <div className="stat-item">
                <span className="stat-icon">❤️</span>
                <strong>{ad.favorites || 0}</strong> Favorites
              </div> */}
            </div>

            <div className="seller-card">
              <h3>{sellerName}</h3>
              <p>Registered Qinto member</p>
              {!isCurrentUserSeller && (
                <button className="btn btn-primary" onClick={openChatWithSeller} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                  <FiMessageSquare />
                  <b>Message Seller</b>
                </button>
              )}
              {isCurrentUserSeller && (
                <button className="btn btn-primary" onClick={() => navigate(`/edit-ad/${ad.id}`)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                  <FiEdit2 />
                  <b>Edit Ad</b>
                </button>
              )}
              <p className="app-install-note">
                <FiLock /> All chats are protected with industry-standard encryption.
                <br /> <span className="app-install-note-highlight">Download the Qinto App for greater experience.</span>
              </p>
            </div>



            <button className="qinto-report-action-btn" onClick={() => setReportAdData(true)} title="Report this ad">
              <FiFlag /> Report this ad
            </button>



            {/* separate block */}
            <div className="download-banner-wrap">
              <img
                src="/assets/qinto_download_Square_Banner.png"
                alt="Download Banner"
                className="download-banner"
              />
            </div>


          </div>

          <div className="ad-detail-content">
            <div className="detail-description">
              <h3>Description</h3>
              <p>{ad.description}</p>
            </div>

            <div className="detail-specs">
              <h3>Details</h3>
              <div className="spec-grid">
                <div><span>Category</span><strong>{ad.category || "Other"}</strong></div>
                <div><span>Sub-Category</span><strong>{ad.subCategory || "Other"}</strong></div>
                <div><span>Location</span><strong>{ad.location || "Not specified"}</strong></div>
                <div>
                  <span>Posted</span>
                  <strong>{ad.createdAt ? new Date(ad.createdAt.seconds * 1000).toLocaleDateString() : "Recently"}</strong>
                </div>

                {displaySpecs.map((field) => {

                  let displayValue = ad[field.name];

                  if (Array.isArray(displayValue)) {
                    displayValue = displayValue.join(', ');
                  }

                  if (typeof displayValue === 'boolean') {
                    displayValue = displayValue ? 'Yes' : 'No';
                  }

                  return (
                    <div key={field.name}>
                      <span>{field.label}</span>
                      <strong>{displayValue} {field.suffix || ''}</strong>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="safety-card">
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FiShield size={'20px'} />
                <h4> Safety Tips</h4>
              </div>

              <ul>
                <li>Meet the seller in a public place</li>
                <li>Inspect the item before paying</li>
                <li>Never share OTP or personal banking details</li>
              </ul>

            </div>
          </div>
        </div>



        <div className="related-section">
          <h3>Similar Listings</h3>
          <FeaturedAds showHeading={false} showExploreButton={false} />
          {adsEnabled && (
            <>
              <div className="listing-label">Advertisement</div>
              <div className="bottom-placement">
                <MultiplexAd />
              </div>
            </>
          )}
        </div>

        {adsEnabled && (
          <>
            <div className="listing-label">Advertisement</div>
            <div className="google-ad-box" ref={adRef => {
              if (adRef && !adRef.getAttribute("data-adsbygoogle-status")) {
                try {
                  (window.adsbygoogle = window.adsbygoogle || []).push({});
                } catch (e) {
                  console.error(e);
                }
              }
            }}>
              <GoogleAd slot="7462032209" style={{ display: "block", width: "100%" }} />
            </div>
          </>
        )}

        <LoginModal
          isOpen={isLoginModalOpen}
          onClose={() => setIsLoginModalOpen(false)} // <-- Set state to FALSE to close
          onSuccess={handleLoginSuccess}
          trigger="chat"
          listingContext={{
            title: ad.title,       // e.g., "Yamaha R6"
            price: `₹ ${ad.price}`,// e.g., "₹ 50,000"
            location: ad.location  // e.g., "Mumbai"
          }}
        />

        {/* Report Ad Modal */}
        <Modal
          isOpen={reportAdData}
          onClose={closeReportAdModal}
          title="Report this advertisement?"
          message={`Think this ad is inappropriate or misleading? Please report it responsibly.\nOur team will review your report and take action if needed.`}
          size="medium"
          icon={<FiFlag size={48} color="#ef4444" />}
          buttons={[
            { label: 'Yes, Report', className: 'danger', onClick: handleReportAd },
            { label: 'Cancel', onClick: closeReportAdModal }
          ]}
        />
      </div>
    </div>
  );
};

export default AdDetail;
